import { render } from "./InformationCircle.vue?vue&type=template&id=70f428c1"
const script = {}
script.render = render

export default script